var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex align-center shop_item"},[_c('img',{staticClass:"shop-icon",attrs:{"width":"20","src":_vm.PLATFORMS_ICONS[_vm.shopItem.source],"alt":""}}),_vm._v(" "+_vm._s(_vm.shopItem.shortTitle || _vm.shopItem.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }